import immer from "immer";
import React, { Fragment, useState } from "react";
import styled from "styled-components";

import { Input } from "App/Atomics/Input";
import { MARGING_LARGE_PX, PADDING_XX_LARGE_PX, pixelize, UNIT, MARGING_X_LARGE_PX, PADDING_X_LARGE_PX } from "constants/size";
import { ARTIST_TYPE_FILTER } from "constants/storageKey";
import { UserRole } from "constants/UserRole";
import { Divider } from "App/Atomics/Divider";
import { ReactComponent as SwapIcon } from "assets/icons/swap.svg";
import { BLUE_6 } from "constants/baseColor";
import { TypeArtistClass } from "App/Routes/Artists/Store/ArtistInfo/sanitizeType";

type Props = Readonly<{
  userRole: string | null;
  typeCheck: TypeArtistClass;
  onClick: (typeCheck: TypeArtistClass) => void;
}>;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow: overlay;

  width: ${pixelize(UNIT * 32.5)};
  height: ${pixelize(UNIT * 25)};
  padding: ${PADDING_XX_LARGE_PX};

  & > button {
    width: ${pixelize(UNIT * 5)};
    margin-top: auto;
    margin-left: auto;
  }
`;

const FilterGroup = styled.section`
  padding: ${PADDING_X_LARGE_PX};
  margin-bottom: ${MARGING_LARGE_PX};

  div {
    grid-template-columns: 30% auto;
    margin-bottom: ${MARGING_LARGE_PX};
  }

  label {
    font-weight: bold;
  }

  hr {
    margin-bottom: ${MARGING_X_LARGE_PX};
  }
`;

const Title = styled.div`
  display: flex;
  column-gap: ${MARGING_LARGE_PX};
  align-items: center;
  margin-left: ${MARGING_LARGE_PX};

  svg {
    width: ${pixelize(UNIT * 1.5)};
    height: ${pixelize(UNIT * 1.5)};
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      fill: ${BLUE_6};
    }
  }
`;

const filterDataEvery = (data: Record<string, boolean>) => {
  return Object.values(data).every(item => {
    return !item;
  });
};

export const TypeFilterModal = ({ userRole, typeCheck: initialType, onClick }: Props) => {
  const [typeCheck, setTypeCheck] = useState(initialType);

  const toSave = () => {
    if (filterDataEvery(typeCheck)) {
      alert("하나 이상은 ON 상태여야 합니다.");
      return;
    }
    window.sessionStorage.setItem(ARTIST_TYPE_FILTER, JSON.stringify({ typeCheck: typeCheck }));
    onClick(typeCheck);
  };

  const toggleVC = (key: keyof typeof typeCheck) => {
    setTypeCheck(tc =>
      immer(tc, draft => {
        draft[key] = !tc[key];
      })
    );
  };

  const toggleAllVC = () => {
    Object.keys(typeCheck).forEach(key => {
      toggleVC(key as keyof typeof typeCheck);
    });
  };

  return (
    <Layout>
      <Title>
        <h3>타입 필터</h3>
        <SwapIcon onClick={toggleAllVC} />
      </Title>
      <Divider />
      <FilterGroup>
        {Object.entries(typeCheck).map(([key, value], index) => (
          <Fragment key={index}>
            <Input.Group isAlign="baseline">
              {(key !== "REMOVE" || userRole === UserRole.Master || userRole === UserRole.Arbeit) && (
                <label>{key !== "V1" ? key : "V1 (NAXOS)"}</label>
              )}
              {(key !== "REMOVE" || userRole === UserRole.Master || userRole === UserRole.Arbeit) && (
                <Input.Toggle color="primary" isActive={value} onClick={() => toggleVC(key as keyof typeof typeCheck)} />
              )}
            </Input.Group>
          </Fragment>
        ))}
      </FilterGroup>
      <Input.Button isWide onClick={toSave}>
        저장
      </Input.Button>
    </Layout>
  );
};
